<template>
  <div class="socialMediaIcons">
    <div>
      <a
        class="btn-floating btn-lg btn-tw wa"
        type="button"
        role="button"
        href="https://www.facebook.com/esportsoccercup"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fab fa-facebook"></i>
      </a>
    </div>
    <div>
      <a
        class="btn-floating btn-lg btn-tw wa"
        type="button"
        role="button"
        href="https://www.instagram.com/esportsoccercup/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fab fa-instagram"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMediaIcons"
};
</script>

<style scoped>
.socialMediaIcons {
  position: fixed;
  top: 50vh;
  left: 15px;
}

.fab {
  padding: 5px;
  border-radius: 50%;
  color: #eb6626;
  font-size: 2em;
}

@media screen and (max-width: 600px) {
  .socialMediaIcons {
    position: fixed;
    top: 50vh;
    left: -5px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1000px){
  .socialMediaIcons {
    position: fixed;
    top: 50vh;
    left: -5px;
  }
}
.wa {
  -webkit-appearance:none !important;
}
</style>